import { Box, HStack, IconButton, Stack, useBreakpointValue } from '@chakra-ui/react'
import { LandingContainer } from 'components/common/LandingContainer'
import { FiveStars } from 'components/svg/FiveStars'
import NewChevronLeft from 'components/svg/NewChevronLeft'
import NewChevronRight from 'components/svg/NewChevronRight'
import { H1, H2, H3, H4, H5 } from 'components/typography'
import { FC, useRef } from 'react'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'

import { formatText } from './WeightQuizSection'

const TestimoniesWeightData = [
  {
    autor: 'A. Fernandes, 28 anos',
    testimony:
      '“Super recomendo! Estou no quinto mês e sinto uma diferença tremenda. Mas o melhor é que minha alimentação melhorou muito e sinto que conseguirei manter minha forma ”'
  },
  {
    autor: 'R. Souza, 29 anos',
    testimony:
      'Por conta do volume de trabalho, eu estava sem tempo para ir para a academia. Com ajuda do personal, montamos um treino pra fazer em casa!'
  }
]

const TestimoniesIshaData = [
  {
    autor: 'Luciana T., 48 anos',
    testimony:
      '“Depois de anos tentando emagrecer sozinha, o Isha me trouxe o acompanhamento que eu precisava. Saber que eu tinha um time dedicado à minha saúde me deu forças para continuar. O acompanhamento diário foi essencial para eu ver resultados a cada dia, além dos hábitos saudáveis que transformaram minha rotina.”'
  },
  {
    autor: 'Patrícia R., 37 anos',
    testimony:
      '“O diferencial do Isha é a personalização e o apoio contínuo. Sempre que eu enfrentava dificuldades, meu plano era ajustado para atender às minhas necessidades. Além disso, o plano alimentar se adequa ao que eu gosto, com dicas e receitas práticas para o dia a dia. Ganhei confiança e equilíbrio!”'
  },
  {
    autor: 'Carla F., 31 anos',
    testimony:
      '“Nunca imaginei que um acompanhamento no meu grupo de WhatsApp dedicado com o meu time pudesse fazer tanta diferença. Com o Isha, recebi todo o suporte que precisava para superar meus desafios e manter o foco. Criei hábitos saudáveis e recuperei minha autoestima.”'
  },
  {
    autor: 'Amanda M., 27 anos',
    testimony:
      '“O Isha é mais do que um programa de emagrecimento, é uma verdadeira transformação de vida! Eu tinha dificuldade em treinar, mas com o suporte do personal e treinos adaptados à minha rotina, consegui transformar esse desafio em hábito. Hoje me sinto mais saudável, confiante e cheia de energia.”'
  }
]
const TestimoniesMedleveData = [
  {
    autor: 'M. A. - 55 anos',
    testimony: '“Fiz tudo pelo celular, em menos de 30 minutos. Comecei meu tratamento no mesmo dia.”'
  },
  {
    autor: 'T. D. - 42 anos',
    testimony: '“O acompanhamento me deixou muito mais segura. Atendimento humano, mesmo sendo online.”'
  }
]

interface WeightTestimoniesSectionProps {
  isha?: boolean
  medleve?: boolean
}

const WeightTestimoniesSection: FC<WeightTestimoniesSectionProps> = ({ isha = false, medleve = false }) => {
  const swiperRef = useRef<SwiperRef>(null)
  const isMobile = useBreakpointValue({ base: true, lg: false })

  const TestimoniesData = isha ? TestimoniesIshaData : medleve ? TestimoniesMedleveData : TestimoniesWeightData

  const goToPrevSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev()
      swiperRef.current.swiper?.update()
    }
  }
  const goToNextSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext()
      swiperRef.current.swiper?.update()
    }
  }
  return (
    <Box
      bg={isha ? 'ishafit.70' : medleve ? 'medleve' : 'greenfit.100'}
      color={isha ? 'ishafit.20' : medleve ? 'alabaster' : 'greenfit.30'}
    >
      <LandingContainer py={{ base: 46, lg: 32 }} px={{ base: '24px', lg: '92px' }} spacing={10}>
        <Box>
          {isMobile ? <H4>Depoimentos</H4> : <H2>Depoimentos</H2>}
          <FiveStars />
        </Box>
        <Swiper ref={swiperRef} slidesPerView={1} spaceBetween={5} style={{ width: '100%' }}>
          {TestimoniesData.map((testimony) => {
            return (
              <SwiperSlide key={testimony.autor}>
                <Stack direction="column" spacing={{ base: 12, lg: 20 }}>
                  <Stack minH={{ base: '380px', lg: '250px' }}>
                    <H3
                      fontWeight={800}
                      fontSize={{ base: '2rem', lg: '3.25rem' }}
                      letterSpacing="-0.04em"
                      lineHeight={{ base: '2.5rem', lg: '3.75rem' }}
                    >
                      {testimony.testimony}
                    </H3>
                  </Stack>
                  <Stack
                    direction="row"
                    justify="space-between"
                    align="center"
                    pb={4}
                    borderBottomWidth={{ base: '2px', lg: '6px' }}
                    borderColor={isha ? '#B34910' : medleve ? 'transparent' : '#264021'}
                    borderStyle="solid"
                  >
                    <H5>{isMobile ? formatText(testimony.autor, ', ') : testimony.autor}</H5>
                    <HStack>
                      <SwiperBtnLeft onClick={goToPrevSlide} isha={isha} medleve={medleve} />
                      <SwiperBtnRight onClick={goToNextSlide} isha={isha} medleve={medleve} />
                    </HStack>
                  </Stack>
                </Stack>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </LandingContainer>
    </Box>
  )
}

export default WeightTestimoniesSection

const SwiperBtnLeft = ({ isha = false, medleve = false, ...props }) => {
  return (
    <IconButton
      aria-label="previous slide"
      width="48px"
      height="48px"
      shadow="none"
      bg={isha ? 'ishafit.40' : medleve ? 'transparent' : 'greenfit.90'}
      icon={<NewChevronLeft height={'16px'} fill={isha ? 'ishafit.70' : medleve ? 'alabaster' : 'greenfit.30'} />}
      _hover={{
        backgroundColor: isha ? 'ishafit.40' : medleve ? 'transparent' : 'greenfit.90'
      }}
      {...props}
    />
  )
}

const SwiperBtnRight = ({ isha = false, medleve = false, ...props }) => {
  return (
    <IconButton
      aria-label="previous slide"
      width="48px"
      height="48px"
      shadow="none"
      bg={isha ? 'ishafit.40' : medleve ? 'transparent' : 'greenfit.90'}
      icon={<NewChevronRight height={'16px'} fill={isha ? 'ishafit.70' : medleve ? 'alabaster' : 'greenfit.30'} />}
      _hover={{
        backgroundColor: isha ? 'ishafit.40' : medleve ? 'transparent' : 'greenfit.90'
      }}
      {...props}
    />
  )
}
